import { render } from "./alert.svg?vue&type=template&id=07b6bb7a"
const script = {}
script.render = render

export default script